import * as tslib_1 from "tslib";
import InfoBarMessageWithCustomAction from './InfoBarMessageWithCustomAction';
import InfoBarMessageWithShowDetailsAction from './InfoBarMessageWithShowDetailsAction';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import * as React from 'react';
import { InfoBarMessageRank, InfoBarMessageColor, } from '../schema/InfoBarMessageViewState';
var styles = require('./InfoBarMessage.scss');
var classNames = require('classnames/bind').bind(styles);
var InfoBarMessage = /** @class */ (function (_super) {
    tslib_1.__extends(InfoBarMessage, _super);
    function InfoBarMessage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textContainerRefGetter = function () {
            return _this.textContainerRef;
        };
        return _this;
    }
    InfoBarMessage.prototype.renderPart = function (part) {
        if (typeof part === 'string') {
            return part;
        }
        else if (part.text) {
            var customAction = part;
            return (React.createElement(InfoBarMessageWithCustomAction, { customAction: customAction, className: styles.link }));
        }
        else {
            var showDetailsAction = part;
            return (React.createElement(InfoBarMessageWithShowDetailsAction, tslib_1.__assign({}, showDetailsAction, { className: styles.link, detailContainerGetter: this.textContainerRefGetter })));
        }
    };
    InfoBarMessage.prototype.render = function () {
        var _this = this;
        // Set safety color binding to null if it's not a safety bar message.
        var safetyColorBinding = this.props.rank == InfoBarMessageRank.Safety
            ? {
                red: this.props.color == InfoBarMessageColor.Red,
                green: this.props.color == InfoBarMessageColor.Green,
                yellow: this.props.color == InfoBarMessageColor.Yellow,
            }
            : null;
        var iconName = this.props.rank == InfoBarMessageRank.Encryption
            ? "Encryption" /* Encryption */
            : "Info" /* Info */;
        var textContainerStyle = classNames(styles.textContainer, styles.textContainerMarginForNewInfoBarUI, this.props.textContainerClassName);
        return (React.createElement("div", { className: classNames(styles.container, styles.newInfoBarUI) },
            React.createElement(Icon, { iconName: iconName, className: classNames(styles.icon, safetyColorBinding) }),
            React.createElement("div", { ref: function (ref) { return (_this.textContainerRef = ref); }, className: textContainerStyle }, this.props.messageParts.map(function (part, index) { return (React.createElement("span", { key: index },
                _this.renderPart(part),
                " ")); }))));
    };
    InfoBarMessage = tslib_1.__decorate([
        observer
    ], InfoBarMessage);
    return InfoBarMessage;
}(React.Component));
export default InfoBarMessage;
//# sourceMappingURL=InfoBarMessage.js.map